export default {
  _default: `The field value is not valid.`,
  alpha_dash: `The field may contain alpha-numeric characters as well as dashes and underscores.`,
  alpha_num: `The field may only contain alpha-numeric characters.`,
  alpha_spaces: `The field may only contain alphabetic characters as well as spaces.`,
  alpha: `The field may only contain alphabetic characters.`,
  between: `The field must be between {min} and {max}.`,
  confirmed: `The field confirmation does not match.`,
  credit_card: `The field is invalid.`,
  date_between: `The field must be between {min} and {max}.`,
  date_format: `The field must be in the format {format}.`,
  decimal: `The field must be numeric and may contain {decimals} decimal points.`,
  digits: `The field must be numeric and exactly contain {length} digits.`,
  dimensions: `The field must be {width} pixels by {height} pixels.`,
  email: `The field must be a valid email.`,
  ext: `The field must be a valid file.`,
  image: `The field must be an image.`,
  in: `The field must be a valid value.`,
  ip: `The field must be a valid ip address.`,
  max: `The field may not be greater than {length} characters.`,
  max_value: `The field must be {max} or less.`,
  mimes: `The field must have a valid file type.`,
  min: `The field must be at least {length} characters.`,
  min_value: `The field must be {min} or more.`,
  not_in: `The field must be a valid value.`,
  numeric: `The field may only contain numeric characters.`,
  regex: `The field format is invalid.`,
  required: `The field is required.`,
  size: `The field must be less than {size} KB.`,
  url: `The field is not a valid URL.`
};



// WEBPACK FOOTER //
// ./src/common/lang/en/validates.js